export default "__VITE_ASSET__6c09d713__"